import {ApiCall} from "../../global/helpers/api"
import {getUser} from "../helpers/actions"
import config from "../../global/config/settings"
import GlobalStore from "../../global/store/GlobalStore"

export default {
	login(recaptchaToken, login, password) {
		return new ApiCall({
			customURL: `${config.API_PUBLIC_URL}/sec/login?g-recaptcha-response=${recaptchaToken}`,
			method: "POST",
			body: {
				login,
				password
			},
			includeToken: false
		})
	},

	registration(req, recaptchaToken) {
		return new ApiCall({
			path: `-pub/client/register?g-recaptcha-response=${recaptchaToken}`,
			method: "POST",
			body: JSON.stringify(req),
			includeToken: false
		})
	},

	registrationFinish(req, token, recaptchaToken) {
		return new ApiCall({
			path: `-pub/client/action-consume/${token}?g-recaptcha-response=${recaptchaToken}`,
			method: "POST",
			body: JSON.stringify(req),
			includeToken: false
		})
	},

	resetPassword(req, recaptchaToken) {
		return new ApiCall({
			path: `-pub/client/reset-password?g-recaptcha-response=${recaptchaToken}`,
			method: "POST",
			body: JSON.stringify(req),
			includeToken: false
		})
	},

	logout() {
		return new ApiCall({
			path: "/sec/logout",
			method: "POST"
		})
	},

	saveRequest(req) {
		return new ApiCall(`/gd/record/proxy`, "PUT", req)
	},
	loadRequestWithAtt(id) {
		return new ApiCall(`/gd/record/proxy-int/${id}?level_flag=CDL4&inclatt=1`, "GET")
	},
	loadPrintRequest(id) {
		return new ApiCall(`/ipcei/record/proxy/${id}?level_flag=CDL5&inclatt=1`, "GET")
	},
	saveCompany(req) {
		return new ApiCall(`/entity/entities`, "PUT", req)
	},
	getEntity(personId) {
		return new ApiCall(`/entity/entities/${personId}?level_flag=CDL3`, "GET")
	},
	saveAttachment(data) {
		return new ApiCall("/object/attachment", "PUT", data)
	},
	saveAttachmentContent(id, content) {
		// return new ApiCall(`/object/attachment/${id}/content`,"POST",content)
		return new ApiCall({
			path: `/object/attachment/${id}/content`,
			method: "POST",
			headers: {
				"Content-Type": "application/octet-stream"
			},
			body: content,
			transform: false
		})
	},
	getRequests(req) {
		return new ApiCall(`/gd/record/overview-int`, "POST", req)
	},

	loadEntityCity(filter) {
		return new ApiCall(`/gd/cl/city`, "POST", filter)
	},

	loadAttachmentData(link) {
		return new ApiCall(`${link}`, "GET")
	},

	getEcho() {
		return new ApiCall(`/discovery/echo`, "GET")
	},

	loadAttachmentTemplates() {
		return new ApiCall(`/ipcei/record/cl/IPCEI.CL.Record.RecordType/IPCEI.Data.Request/attachments`, "GET")
	},

	downloadFile(path, fileName) {
		const user = getUser()
		GlobalStore.loading(true)
		fetch(`${config.API_BASE_URL}${path}`, {
			method: "GET",
			mode: "cors",
			headers: {
				Authorization: `SIEA ${user.sieatoken || ""}`
			}
		})
			.then((response) => {
				if (response.status === 401) {
					GlobalStore.setNotificationMessage("Nemáte oprávnenia k sťahovaniu tohto súboru", "", "error")
				} else {
					response.blob().then((blob) => {
						var FileSaver = require("file-saver") // eslint-disable-line no-undef
						FileSaver.saveAs(blob, fileName || "file")
					})
				}
				GlobalStore.loading(false)
			})
			.catch(() => {
				GlobalStore.loading(false)
			})
		// return new ApiCall(`${path}`, "GET");
	},

	loadCalls() {
		return new ApiCall(`/inn/record/calls`, "POST")
	},

	exportToXLS(data) {
		return new ApiCall(`/object/exportfilled`, "POST", data)
	},

	loadCompanyInfo(id) {
		return new ApiCall(`/entity/entities/${id}?level_flag=CDL3`, "GET")
	},

	regionRestriction(req) {
		return new ApiCall(`/inn/record/regionrestriction`, "POST", req)
	},

	downloadAttachment(id) {
		return new ApiCall(`/object/attachment/${id}/redirect`, "GET")
	},

	getAllocations(req) {
		return new ApiCall(`/gd/record/allocations-int`, "POST", req)
	},

	getSettings(req) {
		return new ApiCall(`/gd/record/rounds-int`, "POST", req)
	},

	getRegistrationsWithoutRequest(req) {
		return new ApiCall(`/gd/record/registrations-int`, "POST", req)
	},

	deleteRegistration(regId) {
		return new ApiCall(`/gd/record/registration-int/${regId}`, "DELETE")
	},

	addRound(req) {
		return new ApiCall(`/gd/record/round-int`, "PUT", req)
	},

	changeRecordStatus(guid, req) {
		return new ApiCall(`/gd/record/request-int/${guid}/status`, "PUT", req)
	},

	exportData(req) {
		return new ApiCall(`/object/export`, "POST", req)
	}
}

